import React from 'react';
import emptyIcon from 'assets/icons/emptyIcon.svg';

const EmptySite = () => {
    return (
        <div className="htEmpty">
            <img src={emptyIcon} alt="emptyIcon" />
            <span className='mt-25'>조회된 데이터가</span>
            <span>없습니다.</span>
        </div>
    );
}

export default EmptySite;